import Markdown from 'markdown-to-jsx'
import PropTypes from 'prop-types'

import { withI18n } from '@thebeansgroup/i18n'

import { consumerGroupIsStudent } from '@src/helpers'

import GradCapGraduateIcon from '../../../images/grad_cap_graduate_icon.svg'
import GradCapIcon from '../../../images/grad_cap_icon.svg'

import { OFFICIAL_EMAIL_FALLBACK } from './constants'
import * as styles from './styles'

export const EmailInputHint = ({ t, consumerGroup }) => {
  const renderIcon = () => {
    if (consumerGroupIsStudent(consumerGroup)) {
      return <GradCapIcon />
    }
    return <GradCapGraduateIcon />
  }

  return (
    <div css={styles.container}>
      <div css={styles.iconContainer}>{renderIcon()}</div>
      <span css={styles.textContainer}>
        <Markdown>
          {t('m_official_student_email') || OFFICIAL_EMAIL_FALLBACK}
        </Markdown>
      </span>
    </div>
  )
}

EmailInputHint.propTypes = {
  t: PropTypes.func.isRequired,
  consumerGroup: PropTypes.string.isRequired
}

export default withI18n(EmailInputHint)
